import React, { useCallback, useRef } from 'react';
import ReCAPTCHA from 'react-google-recaptcha';

import { ClientFormLogin } from '@/@types/client';
import Button from '@/components/Button';
import FormInput from '@/components/Form/Input';
import { Loader } from '@/components/Loader';
import { useAuth } from '@/contexts/auth';
import { useFormValues } from '@/hooks/use-form-values';

import * as S from './styles';

type Props = {
  onSuccess: () => void;
  onClickRecoverPassword?: () => void;
};

const Login = ({ onSuccess, onClickRecoverPassword }: Props) => {
  // const recaptchaRef = React.createRef();
  const recaptchaRef = useRef<ReCAPTCHA>(null);
  const { handleLogin } = useAuth();

  const {
    formValues,
    loadingFormValues,
    handleChangeFormValues,
    handleClearFormValues,
    handleSubmitFormValues,
  } = useFormValues<ClientFormLogin>({
    login: '',
    password: '',
  });

  const onSubmit = useCallback(
    async (_, values) => {
      const recaptchaValue = recaptchaRef.current.getValue();
      if (!recaptchaValue) {
        alert('Necessário marcar o captcha');
        return;
      }
      values.captcha = recaptchaValue;

      await handleLogin(values);
      handleClearFormValues();
      recaptchaRef.current.reset();
      onSuccess();
    },
    [handleClearFormValues, handleLogin, onSuccess],
  );

  return (
    <S.Wrapper onSubmit={handleSubmitFormValues(onSubmit)}>
      <FormInput
        required
        name="login"
        value={formValues.login}
        onChange={handleChangeFormValues}
        mask="###.###.###-##"
        placeholder="Digite seu cpf"
        replace={{ to: /[^0-9]/g }}
      />

      <FormInput
        required
        name="password"
        value={formValues.password}
        placeholder="Digite sua senha"
        type="password"
        onChange={handleChangeFormValues}
      />

      <ReCAPTCHA
        hl="pt-br"
        ref={recaptchaRef}
        size="normal"
        sitekey={process.env.NEXT_PUBLIC_RECAPTCHA_SITE_KEY}
      />

      <S.RememberAndRecover>
        {/* <label htmlFor="remember">
          <input type="checkbox" name="remember" id="remember" />
          <span>Permanecer Conectado</span>
        </label> */}

        <button type="button" onClick={onClickRecoverPassword}>
          Esqueci a senha
        </button>
      </S.RememberAndRecover>

      <Button type="submit" disabled={loadingFormValues}>
        {loadingFormValues ? <Loader /> : 'Entrar'}
      </Button>
    </S.Wrapper>
  );
};

export default React.memo(Login);
